import { VALIDATION_RULES, MESSAGES } from '../constants/inventoryArticlesConstants';

export const filterInventoryArticles = (articles = [], searchTerm = '', filters = {}) => {
  const normalized = searchTerm?.trim().toLowerCase();

  return articles.filter((article) => {
    const matchesSearch =
      !normalized ||
      article.code?.toLowerCase().includes(normalized) ||
      article.name?.toLowerCase().includes(normalized) ||
      article.description?.toLowerCase().includes(normalized) ||
      article.external_code?.toLowerCase().includes(normalized);

    const matchesStatus =
      !filters.status ||
      filters.status === 'all' ||
      (filters.status === 'active' && article.is_active) ||
      (filters.status === 'inactive' && !article.is_active);

    return matchesSearch && matchesStatus;
  });
};

export const validateInventoryArticle = (formData) => {
  const errors = {};

  VALIDATION_RULES.REQUIRED_FIELDS.forEach((field) => {
    if (!formData[field] || `${formData[field]}`.trim() === '') {
      errors[field] = MESSAGES.ERROR.REQUIRED_FIELD;
    }
  });

  if (formData.code && formData.code.length > VALIDATION_RULES.CODE_MAX_LENGTH) {
    errors.code = `Máximo ${VALIDATION_RULES.CODE_MAX_LENGTH} caracteres`;
  }

  if (formData.name && formData.name.length > VALIDATION_RULES.NAME_MAX_LENGTH) {
    errors.name = `Máximo ${VALIDATION_RULES.NAME_MAX_LENGTH} caracteres`;
  }

  if (
    formData.external_code &&
    formData.external_code.length > VALIDATION_RULES.EXTERNAL_CODE_MAX_LENGTH
  ) {
    errors.external_code = `Máximo ${VALIDATION_RULES.EXTERNAL_CODE_MAX_LENGTH} caracteres`;
  }

  return errors;
};

export const getUnitDescription = (units = [], uuidUnit) => {
  if (!uuidUnit) return '-';
  const unit = units.find((item) => item.uuid === uuidUnit);
  return unit?.description || '-';
};
